<app-reporting-dialog-greenness
  *ngIf="displayGreennessSurvey || showGreennessNotification !== null"
  [appLocation]="customer.app_location"
  [dialogType]="showGreennessNotification === null ? 'survey' : 'notification'"
  [showSurvey]="customer.show_greenness_survey"
  [success]="showGreennessNotification"
  (dismissSurvey)="onDismissSurvey($event)"
  (submitSurvey)="onSubmitSurvey($event)"
>
</app-reporting-dialog-greenness>

<app-reporting-dialog-odd
  *ngIf="displayOddModal"
  [name]="customer.first_name"
  [oddDate]="customer.saxo_data_renewal_expires_at"
  (review)="onReview()"
  (doItLater)="onDoItLater()"
>
</app-reporting-dialog-odd>

<section [class.show-eve2-banner]="(showEve2Banner$ | async) || (showEve23aBanner$ | async)">
  @if ((showEve2Banner$ | async) && (currentAccount.kind === '3b' || currentAccount.kind === 'kid')) {
    <div class="eve2-banner">
      <div class="ds-running-2">
        <strong>{{ 'EVE2.notification.title' | translate }}.&nbsp;</strong>
        <span class="ds-running-2">&nbsp;{{ 'EVE2.notification.description' | translate }}. &nbsp;</span>
        <a class="ds-running-2" [href]="eve2BannerUrl" target="_blank">{{ 'EVE2.notification.link' | translate }} →</a>
      </div>
    </div>
  }

  @if ((showEve23aBanner$ | async) && currentAccount.kind === '3a') {
    <div class="eve2-banner">
      <div class="ds-running-2">
        <strong>{{ 'EVE2.notification.title' | translate }}.&nbsp;</strong>
        <span class="ds-running-2">&nbsp;{{ 'EVE2.notification.description_3a' | translate }}. &nbsp;</span>
        <a class="ds-running-2" [href]="eve2BannerUrl" target="_blank">{{ 'EVE2.notification.link' | translate }} →</a>
      </div>
    </div>
  }

  <router-outlet></router-outlet>
  <app-reporting-disclaimer *ngIf="currentAccount.kind === '3a' && currentAccount.step_status === 5">
    <p class="disclaimer" [innerHTML]="'performance.libertyDisclaimer.content' | translate"></p>
  </app-reporting-disclaimer>
</section>
